import React from 'react';
import OtpAuthCard from '../components/OtpAuthCard';

export default function UserRegister() {
  return (
    <OtpAuthCard
      mode="register"
      title="Create account with OTP"
      subtitle="Add your name and phone number once. After that, login is only OTP."
    />
  );
}
